/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
} from './SortOrder';

/**
 * 
 * @export
 * @interface PageRequest
 */
export interface PageRequest {
    /**
     * Zero-based page index.
     * @type {number}
     * @memberof PageRequest
     */
    page: number;
    /**
     * Requested records per page. The server caps this value at 100.
     * @type {number}
     * @memberof PageRequest
     */
    pageSize: number;
    /**
     * Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.
     * @type {string}
     * @memberof PageRequest
     */
    sortBy?: string;
    /**
     * 
     * @type {SortOrder}
     * @memberof PageRequest
     */
    sortOrder?: SortOrder;
}

/**
 * Check if a given object implements the PageRequest interface.
 */
export function instanceOfPageRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "pageSize" in value;

    return isInstance;
}

export function PageRequestFromJSON(json: any): PageRequest {
    return PageRequestFromJSONTyped(json, false);
}

export function PageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'sortBy': !exists(json, 'sortBy') ? undefined : json['sortBy'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : SortOrderFromJSON(json['sortOrder']),
    };
}

export function PageRequestToJSON(value?: PageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'sortBy': value.sortBy,
        'sortOrder': SortOrderToJSON(value.sortOrder),
    };
}

